import {useShallow} from "zustand/react/shallow";
import {useListingsStore} from "../../stores/listingsStore";
import {useSavedDealershipsStore} from "../../stores/savedDealershipsStore";

// Same rule resolveDealerIds uses: a dealer is "relevant" if it carries the
// searched make, or its makes are unknown (empty) so we can't rule it out.
const dealerCarriesMake = (dealer, make) => {
    if (!make) return true
    const makes = dealer.makes || []
    if (makes.length === 0) return true
    const target = String(make).toLowerCase()
    return makes.some((m) => String(m).toLowerCase() === target)
}

// Sliding toggle: "My Dealers" narrows the search to the user's saved dealership
// ids; "All Dealers" clears the filter. The concrete ids are resolved at request
// time and filtered to the searched make (see listingsStore.resolveDealerIds), so
// "My Dealers" is only meaningful when some saved dealers carry the make —
// otherwise it's disabled and the thumb reflects "All Dealers".
export function DealerToggle() {
    const saved = useSavedDealershipsStore((state) => state.saved)
    const {make, dealerMode, setDealerMode} = useListingsStore(
        useShallow((state) => ({
            make: state.filters.searchTags.make,
            dealerMode: state.dealerMode,
            setDealerMode: state.setDealerMode,
        }))
    )

    const relevantCount = saved.filter((d) => dealerCarriesMake(d, make)).length
    const hasRelevant = relevantCount > 0
    const myActive = hasRelevant && dealerMode === 'my'

    const disabledTitle = saved.length
        ? `None of your saved dealers carry ${make}`
        : 'Save dealerships to filter by them'

    return (
        <div className="dealer-toggle-wrap">
            <div className={`dealer-slider ${myActive ? 'state-mine' : 'state-all'}`}>
                <div className="dealer-slider-thumb"/>
                <button
                    type="button"
                    className={`dealer-slider-option ${myActive ? 'active' : ''}`}
                    onClick={() => { if (hasRelevant && dealerMode !== 'my') setDealerMode('my') }}
                    disabled={!hasRelevant}
                    title={hasRelevant ? '' : disabledTitle}
                >
                    My Dealers
                </button>
                <button
                    type="button"
                    className={`dealer-slider-option ${!myActive ? 'active' : ''}`}
                    onClick={() => { if (dealerMode !== 'all') setDealerMode('all') }}
                >
                    All Dealers
                </button>
            </div>
        </div>
    );
}
